import React from 'react';
import loader from 'assets/img/loader.svg';
import {LoaderDivStyled} from './style';

interface Props {
  show: boolean;
}

const Loader = (props: Props) => {
  if(props.show) {
    return (
      <LoaderDivStyled>
        <img className="img-loader" src={loader} />
      </LoaderDivStyled>
    )
  }

  return <></>;
}

export default Loader;